import NavBar from './navbar/navBar';
import './ScheduleModification.scss';
import { ReactComponent as EllipseIcon } from '../../assets/icons/ellipse.svg';
import TripleToggleComponent from '../../components/tripleToggleComponent/tripleToggleComponent';
import DateInput from './dateInput/DateInput';
import { DropDown } from 'components/inputBox/inputBox';
import TimePicker from './time-picker/time-picker';
import GreenRoundTick from '../../assets/icons/greenTickRound.png';

const ScheduleModification = () => {
  return (
    <div className="scheduleModificationComponent">
      <NavBar />
      <div className="container">
        <div className="breadCrumb">
          <div className="mainScreen">직원목록</div> {'>'}
          <div className="secondScreen">근무일정</div>
        </div>

        <div className="nameContainer">
          <div className="image">길동</div>
          <div className="nameText">홍길동</div>
        </div>

        <div className="cardContainer">
          <div className="leftContainer">
            <div className="title">일정정보 </div>

            <div className="settings">
              <div className="labels">
                <div className="labelRow">
                  <div className="icon">
                    <EllipseIcon />
                  </div>

                  <div className="labelText">일하는 방식</div>
                </div>
                <div className="labelRow second">
                  <div className="icon">
                    <EllipseIcon />
                  </div>

                  <div className="labelText">일하는 방식</div>
                </div>
                <div className="labelRow third">
                  <div className="icon">
                    <EllipseIcon />
                  </div>

                  <div className="labelText">반복기간</div>
                </div>
                <div className="labelRow fourth">
                  <div className="icon">
                    <EllipseIcon />
                  </div>

                  <div className="labelText ">근무 요일</div>
                </div>
                <div className="labelRow fifth">
                  <div className="icon">
                    <EllipseIcon />
                  </div>

                  <div className="labelText ">총 근무 시간</div>
                </div>
              </div>
              <div className="controls">
                <TripleToggleComponent />
                <div className="dateInputWrapper">
                  <DateInput title="" placeHolder="시작일 선택" />

                  <DateInput title="" placeHolder="종료일 선택" hasDisabled />
                </div>
                <div className="dropDownWrapper">
                  <DropDown options={['월, 화, 목, 금', 'test']} />
                </div>
                <div className="timePickerRow">
                  <div className="timer">
                    <TimePicker setData={() => {}} />
                  </div>
                  <div className="dropDown">
                    <DropDown options={['월, 화, 목, 금', 'test']} />
                  </div>
                </div>
                <div className="rightDivider"> </div>
              </div>
            </div>

            <div className="hourContainer">
              <div className="leftContainerText">주 52시간</div>
              <div className="rightContainerText">
                <img src={GreenRoundTick} alt="" className="tick" />
                적합한 설정입니다
              </div>
            </div>
          </div>

          <div className="rightContainer">
            <div className="title first">일정템플릿이란?</div>
            <div className="description">여기에는 내용이 들어갑니다.</div>

            <div className="title second">일정템플릿이란?</div>
            <div className="description">여기에는 내용이 들어갑니다.</div>
            <div className="title third">일정템플릿이란?</div>
            <div className="description">여기에는 내용이 들어갑니다.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleModification;
